/* eslint-disable react/display-name */
import React from 'react';

import * as olInteraction from 'ol/interaction';
import * as proj from 'ol/proj';
import Map from 'ol/Map';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import View from 'ol/View';
import { connect, useSelector } from 'react-redux';
import { defaults as defaultControls, ScaleLine } from 'ol/control';

import HeightUnitSwitch from 'components/common/components/heightUnitSwitch/HeightUnitSwitch';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Icons from '../../consts/icons';
import MapLegend from './MapLegend';
import UserSessionDataHandler from '../../auth/UserSessionsDataHandler';
import {
  createLayerForJurisdiction,
  createLayerForTransmissionTowers,
  returnMapLayer,
  returnWeatherLayer,
} from './mapUtils';
import { setMap } from '../../store/actions/map/map';
import { useStyles } from './MapRenderUseStyles';

const MapRender = props => {
  const { map, weatherLayer, language } = props;
  const { dispatch } = props;

  const classes = useStyles();
  const classesButtons = ButtonsUseStyles();

  const createMap = () => {
    const layers = [
      returnMapLayer(UserSessionDataHandler.getUserSettingsObject().tiles),
      returnWeatherLayer(),
    ];

    const scaleLineControl = new ScaleLine({
      className: `${classes.MapRender}__box__controls__scale-line`,
      target: 'map-box-controls-scale',
      units: 'metric',
    });

    const renderedMap = new Map({
      controls: defaultControls().extend([scaleLineControl]),
      target: 'map',
      renderer: 'webgl',
      layers,
      view: new View({
        center: proj.fromLonLat([19.015839, 52.2307]),
        zoom: 6,
      }),
      interactions: olInteraction.defaults({ doubleClickZoom: false }),
    });
    renderedMap.addLayer(createLayerForJurisdiction());
    renderedMap.addLayer(createLayerForTransmissionTowers());
    fitMapToJurisditionLayerExtent(renderedMap);
    dispatch(setMap(renderedMap));
  };

  React.useEffect(() => {
    createMap();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fitMapToJurisditionLayerExtent = mapObject => {
    mapObject.getView().dispatchEvent('change:fitToJurysdiction');
  };

  const useString = () => {
    // eslint-disable-next-line no-shadow
    const language = useSelector(state => state.language);
    return language.map.resizer;
  };
  const subtitles = useString();

  return (
    <div className={classes.MapRender}>
      <div className={`${classes.MapRender}__box`} id="map">
        <div className={`${classes.MapRender}__box__icon--z-index`}>
          <div
            className={`${classes.MapRender}__box__icon__outer ${classesButtons.Buttons} ${classesButtons.ButtonsCircle}`}
          >
            <Tooltip
              title={subtitles.centerMap_}
              placement="bottom-end"
              leaveDelay={200}
              className={`${classes.MapRender}__box__icon__tooltip`}
            >
              <Icons.Actions.ControlCamera
                className={`${classes.MapRender}__box__icon__inner  ${classesButtons.Buttons}--color`}
                onClick={() => fitMapToJurisditionLayerExtent(map)}
              />
            </Tooltip>
          </div>
          <HeightUnitSwitch />
        </div>
        <div className={`${classes.MapRender}__box__controls__scale`}>
          <div
            className={`${classes.MapRender}__box__controls__scale__inner`}
            id="map-box-controls-scale"
          ></div>
        </div>
        <MapLegend
          weatherLayer={weatherLayer}
          legendName={language.weather.legendBar[`${weatherLayer}_`]}
        />
      </div>
    </div>
  );
};

MapRender.propTypes = {
  dispatch: PropTypes.func.isRequired,
  map: PropTypes.object.isRequired,
  weatherLayer: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.instanceOf(null).isRequired,
  ]),
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  map: state.map,
  weatherLayer: state.weatherLayer,
  language: state.language,
});

export default connect(mapStateToProps)(MapRender);
